<template>
  <div class="change_device_count">
    <div class="header">
      <h4 class="title">
        {{ translate("client_order.change_device_count") }}
      </h4>
    </div>
    <div class="content">
      <div class="info-item">
        <fg-input
            type="number"
            v-model="client_order_info.device_count"
            :readonly="false"
            :min="client_order_info.devices.length"
            :max="500"
            :placeholder="translate('client_order.device_count')"
            :label="translate('client_order.device_count')"
        />
      </div>
      <div class="info-item">
      </div>
    </div>

    <div class="footer">
      <span
          class="btn btn-info btn-fill btn-wd marginButton"
          @click.prevent="edit_client_order"
          :disabled="!has_checked"
      >
        {{ translate('btn.edit') }}
      </span>

      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from "xterm-addon-fit"

export default {
  name: "ChangeDeviceCount",
  props: ["client_order"],
  data () {
    return {
      client_order_info: {}
    }
  },
  computed:{
    has_checked(){
      return Number(this.client_order_info.device_count) !== Number(this.client_order.device_count)
    }
  },
  created() {
    this.client_order_info = {...this.client_order}
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    edit_client_order() {
      if (!this.has_checked) return
      if (this.client_order_info.device_count >= this.client_order_info.devices.length) {
        this.client_order_info.device_count = Number(this.client_order_info.device_count)
        this.$http.v1.updateClientOrder(this.client_order_info.id, this.client_order_info, (response) => {
          this.global_notify('info', this.translate('client_order.saved_success'))
          this.$emit('update', response.data)
        })
      }else{
        this.global_notify('danger', this.translate('client_order.change_device_count_error'))
      }
    },
  }
}

</script>

<style lang='scss' scoped>
  .change_device_count{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .info-item{
        width: 100%;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
